import React from 'react';
export function TicketDivider() {
  return <div className="w-full h-8 flex items-center justify-center my-12 overflow-hidden" aria-hidden="true" data-id="element-237">
      <div className="w-full border-b-2 border-dashed border-warm-gray/30 relative" data-id="element-238">
        <div className="absolute -left-3 -top-3 w-6 h-6 rounded-full bg-[#FDF8F4] border-r-2 border-dashed border-warm-gray/30" data-id="element-239" />
        <div className="absolute -right-3 -top-3 w-6 h-6 rounded-full bg-[#FDF8F4] border-l-2 border-dashed border-warm-gray/30" data-id="element-240" />
      </div>
    </div>;
}